import { createIcon } from "@chakra-ui/react";

export const Intercomm = createIcon({
  displayName: "Intercomm",
  viewBox: "0 0 24 24",
  path: [
    <path
      fill="currentColor"
      fillRule="evenodd"
      clipRule="evenodd"
      d="M24 3.06a3 3 0 0 0-3-3H3a3 3 0 0 0-3 3v12a3 3 0 0 0 3 3h14.379a1.5 1.5 0 0 1 1.06.439l4.28 4.28a.75.75 0 0 0 1.281-.53V3.058zm-16.5 6a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm6 0a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0zm4.5 1.5a1.5 1.5 0 1 0 0-3 1.5 1.5 0 0 0 0 3z"
    />,
  ],
  defaultProps: {
    "aria-label": "A speech bubble with three dots within"
  }
});

export default Intercomm;
